module.exports = "<app-navbar></app-navbar>\n<app-header></app-header>\n<app-services></app-services>\n<app-why-arda></app-why-arda>\n<app-special-travels></app-special-travels>\n<app-home-travels></app-home-travels>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/rafaelneves/code/ads/ardaexperience/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main